import React, { useCallback, useState } from 'react';
import { map, get, noop } from 'lodash';
import { getLabel } from 'utils/getLabel';
import { Icon } from 'modules/icon-bank';
import classnames from 'classnames';
import { withNetworkState } from 'ui/hoc/withNetworkState';
import SimpleBar from 'simplebar-react';
import { popover } from 'modules/popover';
import { dropDownActionList as DropDownActionList } from 'modules/drop-down-action-list';

const ASSISTIVE_ACTION_ICON = {
    switchDrugPreference: 'drugPreference',
    viewIdCard: 'idCard',
    addInsurance: 'notesAdd',
    priorAuthorization: 'priorAuthorization',
    drugPricing: 'priceTag',
    materialMailOut: 'mail',
    impersonate: 'userProfile',
    deactivateInEpost: 'deactivateMember',
    reactivateEpost: 'reactivateUser',
    enrollToEpost: 'enroll',
    manualOrder: 'manualOrder',
    websiteIssues: 'website',
    memberServiceEscalation: 'danger',
    memberEscalationCall: 'slimPhone',
    ePostNotes: 'notes',
    memberBusinessProcessTodo: 'businessProcess',
    userId: 'userId',
    personalId: 'personalId2',
    patientNotes: 'stickyNotes',
    outboundCalls: 'phoneForward',
    statusOfClaim: 'checkedContent',
    cmsAction: 'businessProcess',
    serviceNowAction: 'serviceNow',
    mailOrder: 'dropDownList',
    languagePreference: 'languagePreference',
    ivrPin: 'ivrpin'
};

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { memberDetailAssistiveActionsNavWidget as MemberDetailAssistiveActionsNavWidget } from 'ui/views/widgets/memberDetailAssistiveActionsNavWidget';
 *
 * // render
 * <MemberDetailAssistiveActionsNavWidget propName='propValue'/>
 */
const _memberDetailAssistiveActionsNavWidget = ( props ) => {

    // get primary options
    const quickActions = get( props, 'quickActions', [] );

    // get visibility
    const visibility = get( props, 'visibility', [] );

    return (
        <div className='ui-member-detail-assistive-actions-nav-widget'>
            <SimpleBar style={ { width: '100%', height: '100%' } }>
                <div className='ui-member-detail-assistive-actions-nav-widget__actions-row'>
                    { map( quickActions, action => {

                    const iconId = ASSISTIVE_ACTION_ICON[ `${action.name}` ];
                    const className= classnames(
                        'ui-member-detail-assistive-actions-nav-widget__actions-row__actions',
                        {
                            'ui-member-detail-assistive-actions-nav-widget__actions-row__actions--disabled': ! visibility[ `${action.visibility}` ],
                            'ui-member-detail-assistive-actions-nav-widget__actions-row__actions--hidden': ! visibility[ `${action.visibility}` ] && get( action, 'config.hideIfDisabled', false ),
                        }
                    );
                    

                    const isActive = visibility[ `${action.visibility}` ];
                    const actionClickEnabled = true;
                    if( 'mailOrder' === action.name && isActive  ) {

                        return (
                            <MailOrderDropdown
                                key={ action.name }
                                action= { action }
                                iconId= { iconId }
                                className= { className }
                                isActive= { isActive }
                                actionClickEnabled={ actionClickEnabled }
                                visibility= { visibility }
                                onActionClick= { actionClickEnabled && props.onActionClick }
                            />
                        );
                        
                    } else {
                        return(
                          isActive ?
                            <div key={ action.name } className={ className } onClick={ () => isActive ? props.onActionClick( { value: action } ) : noop }>
                                <div className='ui-member-detail-assistive-actions-nav-widget__actions-row__actions__i'>
                                    <Icon id={ iconId } fill= { visibility[ `${action.visibility}` ] ? '#003E7B': '#7a7a7a' } width={ 17 } height={ 16 } />
                                </div>
                                <div className='ui-member-detail-assistive-actions-nav-widget__actions-row__actions__title'> { getLabel( action.title ) } </div>
                            </div>
                            : null
                        );
                    }


                } ) }
                </div>
            </SimpleBar>
        </div>
    );
};

// set display name
_memberDetailAssistiveActionsNavWidget.displayName = 'memberDetailAssistiveActionsNavWidget';

// set default props
_memberDetailAssistiveActionsNavWidget.defaultProps = {};

// prop types
_memberDetailAssistiveActionsNavWidget.propTypes = {};

// /************************************* */

const memberDetailAssistiveActionsNavWidgetPreloader = ( ) => {

    return (
        <div className='ui-member-detail-assistive-actions-nav-widget-preloader'>
            { map( [ ...Array( 10 ).keys() ], item => {
                return (
                    <div key={ item } className='ui-member-detail-assistive-actions-nav-widget-preloader__items'>
                        <div className='ui-member-detail-assistive-actions-nav-widget-preloader__items__item'></div>
                        <div className='ui-member-detail-assistive-actions-nav-widget-preloader__items__title'></div>
                    </div>
                );
            } ) }
        </div>
    );
};

// // set display name
memberDetailAssistiveActionsNavWidgetPreloader.displayName = 'memberDetailAssistiveActionsNavWidgetPreloader';

// // set default props
memberDetailAssistiveActionsNavWidgetPreloader.defaultProps = {};

// // prop types
memberDetailAssistiveActionsNavWidgetPreloader.propTypes = {};

/************************************* */


export const memberDetailAssistiveActionsNavWidget = withNetworkState( memberDetailAssistiveActionsNavWidgetPreloader, _memberDetailAssistiveActionsNavWidget );

// ======= MailOrderDropdown drop down view =========
const MailOrderDropdown = ( props ) => {

    const { action, iconId, className, isActive, visibility, onActionClick, actionClickEnabled } = props;
    const [ showUnavailable, setShowUnavailable ] = useState( false );
    const options = get( action, 'options', [] ) || [];
    const hasAvailableActions = options.some( option => visibility[ option.visibility ] );

    // open popover options
    const openPopover = useCallback( ( element ) => {
        if( !hasAvailableActions ) {
            setShowUnavailable( true );
            return;
        }
        setShowUnavailable( false );
        popover.open( {
            referenceElement: element,
            view: DropDownActionList,
            tooltip: false,
            props: {
                width: props.flyoutWidth,
                onActionClick: noop,
                actions: map( options, option => {

                    const isActiveOption = Boolean( visibility[ `${option.visibility}` ] );

                    const optionClassName= classnames(
                        'ui-member-detail-assistive-actions-nav-widget__actions-row__actions__mailorder-action',
                        {
                            'ui-member-detail-assistive-actions-nav-widget__actions-row__actions--disabled': ! visibility[ `${option.visibility}` ],
                            'ui-member-detail-assistive-actions-nav-widget__actions-row__actions--hidden': ! visibility[ `${option.visibility}` ] && get( option, 'config.hideIfDisabled', false ),
                        }
                    );
                        
                    return {
                        ...option,
                        iconName: ASSISTIVE_ACTION_ICON[ `${option.name}` ],
                        className: optionClassName,
                        onActionClick: () => isActiveOption ? onActionClick( { value: option } ) : noop,
                        disabled: !isActiveOption,
                        checkVisiable: isActiveOption
                    };
                } ),
            }
        } );
    }, [ hasAvailableActions, options, visibility, onActionClick, props.flyoutWidth ] );

    return (
      
        <>
        <button type='button' className={ `${className} ui-member-detail-assistive-actions-nav-widget__mail-order-trigger` } aria-haspopup={ hasAvailableActions ? 'true' : undefined } onClick={ ( event ) => (actionClickEnabled && isActive) ? openPopover( event.currentTarget ): noop }>
            <span className='ui-member-detail-assistive-actions-nav-widget__actions-row__actions__i'>
                <Icon id={ iconId } fill= { visibility[ `${action.visibility}` ] ? '#003E7B': '#7a7a7a' } width={ 17 } height={ 16 } />
            </span>
            <span className='ui-member-detail-assistive-actions-nav-widget__actions-row__actions__title'> { getLabel( action.title ) }
            <span className= 'ui-member-detail-assistive-actions-nav-widget__actions-row__actions__title__dropdown-tip'/>
            </span>
        </button>
        { showUnavailable && !hasAvailableActions && (
            <div role='status' className='ui-member-detail-assistive-actions-nav-widget__mail-order-unavailable'>
                No Mail Order actions are currently available for this member. Check current status or contact support.
            </div>
        ) }
        </>
    );
};

// set display name
MailOrderDropdown.displayName = 'MailOrderDropdown';

